import { Injectable } from '@angular/core';

import { ignoreElementsTyped } from '@frontend/sports/common/core/utils/rxjs';
import { PopupManager } from '@frontend/sports/popup/feature';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs';

import DigitalActions from './actions';

@Injectable()
export default class Effects {
    constructor(
        private actions: Actions,
        private popupManager: PopupManager,
    ) {}

    closePopup$ = createEffect(
        () => {
            return this.actions.pipe(
                ofType(DigitalActions.closePopup),
                tap(() => this.popupManager.close()),
                ignoreElementsTyped(),
            );
        },
        { dispatch: false },
    );
}
